var showroom = "https://shopfront-cdn.tekoapis.com/static/b0d0161a0c69c7a1.svg";

export { showroom as default };
